import ArticleSection from "../../components/Article/ArticleSection";
import Page from "../../finwell/pages/Page";

const NewsnArticles = () => {
    
   
    return (
        <Page>
            <ArticleSection />
        </Page>
    )
}

export default NewsnArticles;